import { gql } from '@apollo/client';
import { SaleItemFragment } from '../fragments/SaleItemFragment';
/**
 * @const SaleItemsQuery
 * @since 1.0.0
 */
export const SaleItemsQuery = gql `
  query SaleItemsQuery($input: SaleItemsInput) {
    saleItems(input: $input) {
      items {
        ...SaleItemFragment
      }
      count
    }
  }

  ${SaleItemFragment}
`;
